import React, { Component } from 'react';

class Divider extends Component {
    render() {
        return(
            <React.Fragment>
                <div style={bar} >
                    <div style={squareWrapper}>
                        <div style={squareFour} />
                        <div style={squareTwo} />
                        <div style={squareFive} />
                        <div style={squareTwo} />
                        <div style={squareThree} />
                        <div style={squareFour} />
                        <div style={squareTwo} />
                        <div style={squareThree} />
                        <div style={squareTwo} />
                        <div style={squareFive} />
                        <div style={squareOne} />
                        <div style={squareTwo} />
                        <div style={squareThree} />
                        <div style={squareFive} />
                        <div style={squareFour} />
                        <div style={squareFive} />
                        <div style={squareOne} />
                        <div style={squareThree} />
                        <div style={squareFive} />
                        <div style={squareFour} />
                        <div style={squareTwo} />
                        <div style={squareFive} />
                        <div style={squareFour} />
                        <div style={squareOne} />
                        <div style={squareFour} />
                        <div style={squareOne} />
                        <div style={squareThree} />
                        <div style={squareFive} />
                        <div style={squareTwo} />
                        <div style={squareFour} />
                        <div style={squareThree} />
                        <div style={squareTwo} />
                        <div style={squareOne} />
                        <div style={squareThree} />
                        <div style={squareOne} />
                        <div style={squareTwo} />
                        <div style={squareFour} />
                        <div style={squareTwo} />
                        <div style={squareOne} />
                        <div style={squareTwo} />
                        <div style={squareFour} />
                        <div style={squareThree} />
                        <div style={squareFive} />
                        <div style={squareTwo} />
                        <div style={squareFour} />
                    </div>
                </div>
                <div style={bar} >
                    <div style={squareWrapper}>
                        <div style={squareThree} />
                        <div style={squareFive} />
                        <div style={squareTwo} />
                        <div style={squareFour} />
                        <div style={squareTwo} />
                        <div style={squareFour} />
                        <div style={squareThree} />
                        <div style={squareTwo} />
                        <div style={squareFive} />
                        <div style={squareTwo} />
                        <div style={squareThree} />
                        <div style={squareFour} />
                        <div style={squareTwo} />
                        <div style={squareThree} />
                        <div style={squareTwo} />
                        <div style={squareThree} />
                        <div style={squareFive} />
                        <div style={squareTwo} />
                        <div style={squareThree} />
                        <div style={squareFive} />
                        <div style={squareFour} />
                        <div style={squareFive} />
                        <div style={squareOne} />
                        <div style={squareThree} />
                        <div style={squareFive} />
                        <div style={squareFour} />
                        <div style={squareTwo} />
                        <div style={squareFive} />
                        <div style={squareFour} />
                        <div style={squareOne} />
                        <div style={squareFour} />
                        <div style={squareOne} />
                        <div style={squareTwo} />
                        <div style={squareFour} />
                        <div style={squareOne} />
                        <div style={squareTwo} />
                        <div style={squareOne} />
                        <div style={squareTwo} />
                        <div style={squareOne} />
                        <div style={squareTwo} />
                        <div style={squareFour} />
                        <div style={squareThree} />
                        <div style={squareFive} />
                        <div style={squareTwo} />
                        <div style={squareFour} />
                    </div>
                </div>
                <div style={bar} >
                    <div style={squareWrapper}>
                        <div style={squareTwo} />
                        <div style={squareOne} />
                        <div style={squareFour} />
                        <div style={squareTwo} />
                        <div style={squareThree} />
                        <div style={squareTwo} />
                        <div style={squareFive} />
                        <div style={squareOne} />
                        <div style={squareFour} />
                        <div style={squareTwo} />
                        <div style={squareFive} />
                        <div style={squareTwo} />
                        <div style={squareThree} />
                        <div style={squareOne} />
                        <div style={squareThree} />
                        <div style={squareFive} />
                        <div style={squareFour} />
                        <div style={squareTwo} />
                        <div style={squareFive} />
                        <div style={squareFour} />
                        <div style={squareOne} />
                        <div style={squareFour} />
                        <div style={squareFive} />
                        <div style={squareOne} />
                        <div style={squareThree} />
                        <div style={squareTwo} />
                        <div style={squareFour} />
                        <div style={squareThree} />
                        <div style={squareTwo} />
                        <div style={squareThree} />
                        <div style={squareFive} />
                        <div style={squareFour} /> 
                        <div style={squareOne} />
                        <div style={squareThree} />
                        <div style={squareFive} />
                        <div style={squareOne} />
                        <div style={squareThree} />
                        <div style={squareOne} />
                        <div style={squareTwo} />
                        <div style={squareFour} />
                        <div style={squareTwo} />
                        <div style={squareOne} />
                        <div style={squareTwo} />
                        <div style={squareTwo} />
                        <div style={squareFour} />
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

const bar = {
    width: '10000px',
    height: '50px',
    backgroundColor: '#bccc8b',
    zIndex: '1000',
    overflow: 'hidden'
}

const squareWrapper = {
    width: '10000px',
    display: 'flex',
    flexDirection: 'row',
}

const squareOne = {
    width: '50px',
    height: '50px',
}

const squareTwo = {
    width: '50px',
    height: '50px',
    backgroundColor: '#b5c486',
}

const squareThree = {
    width: '50px',
    height: '50px',
    backgroundColor: '#aebd80',
}

const squareFour = {
    width: '50px',
    height: '50px',
    backgroundColor: '#a7b57b',
}

const squareFive = {
    width: '50px',
    height: '50px',
    backgroundColor: '#a0ad76',
}

export default Divider;
